//---------------------- Videos Import -------------------------------
import video1 from '../../assets/videos/ARENA CLUB NEGOTIN.mp4';
import video2 from '../../assets/videos/bella nella.mp4';
import video3 from '../../assets/videos/club infinity.mp4';
import video4 from '../../assets/videos/safari.mp4';
import video5 from '../../assets/videos/Snapinsta.app_video_AQMWigk79YknDQigAN57kZmytD9vALI06G6fuIRn0tekKlr8Br-ClAqW8LnYFEyqbjnxDLcaL2UwBg18ORcXiqWY.mp4';
import video6 from '../../assets/videos/Sunset fest.mp4';
import video7 from '../../assets/videos/wildnes fest 1.mp4';
import video8 from '../../assets/videos/wildnes fest.mp4';
import video9 from '../../assets/videos/Deki Safari 3.mp4';
import video10 from '../../assets/videos/Deki Safari 4.mp4';
import video11 from '../../assets/videos/Deki Safari 5.mp4';
import video12 from '../../assets/videos/Deki Wildness 2025-2.mp4';
import video13 from '../../assets/videos/Deki i Ema sunset 2-2.mp4';



//---------------------- Videos Export -------------------------------
const videoList = [
  video13,
  video12,
  video9,
  video10,
  video11,
  video2,
  video3,
  video4,
  video5,
  video6,
  video7,
  video8,
  
  video1,
];

// Same order as videoList, with names for the gallery player
export const galleryVideos = [
  { src: video13, title: 'Deki i Ema · Sunset Fest' },
  { src: video12, title: 'Wildness Fest 2025' },
  { src: video9, title: 'Safari ABC' },
  { src: video10, title: 'Safari ABC' },
  { src: video11, title: 'Safari ABC' },
  { src: video2, title: 'Bella Nella' },
  { src: video3, title: 'Club Infinity' },
  { src: video4, title: 'Safari ABC' },
  { src: video5, title: 'Nastup' },
  { src: video6, title: 'Sunset Fest' },
  { src: video7, title: 'Wildness Fest' },
  { src: video8, title: 'Wildness Fest' },
  { src: video1, title: 'Arena Club Negotin' },
];

export default videoList;
